import { IFormErrors } from '@interfaces/IFormsErrors';
import { IMassHolidays, IPeriod } from '@interfaces/IPeriod';
import { Action } from '@ngrx/store';

export enum EPeriodsChangesActions {
  CreatePeriodRequest = '[Periods] Create Period Request',
  CreatePeriodSuccess = '[Periods] Create Period Success',
  CreatePeriodFailure = '[Periods] Create Period Failure',
  ClearCreatePeriodErrors = '[Periods] Clear Create Period Errors',

  UpdatePeriodRequest = '[Periods] Update Period Request',
  UpdatePeriodSuccess = '[Periods] Update Period Success',
  UpdatePeriodFailure = '[Periods] Update Period Failure',
  ClearUpdatePeriodErrors = '[Periods] Clear Update Period Errors',

  DeletePeriodRequest = '[Periods] Delete Period Request',
  DeletePeriodSuccess = '[Periods] Delete Period Success',
  DeletePeriodFailure = '[Periods] Delete Period Failure',
  ClearDeletePeriodErrors = '[Periods] Clear Delete Period Errors',

  AddHolidaysToPeriodRequest = '[Periods] Add Holidays To Period Request',
  AddHolidaysToPeriodSuccess = '[Periods] Add Holidays To Period Success',
  AddHolidaysToPeriodFailure = '[Periods] Add Holidays To Period Failure',
  ClearAddHolidaysToPeriodErrors = '[Periods] Clear Add Holidays To Period Errors',
  AddHolidaysToSeveralGroupsRequest = '[Periods] Add Holidays To Several Groups Request',
  AddHolidaysToSeveralGroupsSuccess = '[Periods] Add Holidays To Several Groups Success',
  AddHolidaysToSeveralGroupsFailure = '[Periods] Add Holidays To Several Groups Failure',
  ClearAddHolidaysToSeveralGroups = '[Periods] Clear Add Holidays To Several Groups',

  DeletePeriodHolidaysRequest = '[Periods] Delete Period Holidays Request',
  DeletePeriodHolidaysSuccess = '[Periods] Delete Period Holidays Success',
  DeletePeriodHolidaysFailure = '[Periods] Delete Period Holidays Failure',
  ClearDeletePeriodHolidaysErrors = '[Periods] Clear Delete Period Holidays Errors',

  SetPeriodThemeRequest = '[Periods] Set Period Theme Request',
  SetPeriodThemeSuccess = '[Periods] Set Period Theme Success',
  SetPeriodThemeFailure = '[Periods] Set Period Theme Failure',
  ClearSetPeriodTheme = '[Periods] Clear Set Period Theme',
}

export class CreatePeriodRequest implements Action {
  public readonly type = EPeriodsChangesActions.CreatePeriodRequest;

  constructor(public data: IPeriod) {}
}

export class CreatePeriodSuccess implements Action {
  public readonly type = EPeriodsChangesActions.CreatePeriodSuccess;
}

export class CreatePeriodFailure implements Action {
  public readonly type = EPeriodsChangesActions.CreatePeriodFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearCreatePeriodErrors implements Action {
  public readonly type = EPeriodsChangesActions.ClearCreatePeriodErrors;
}

export class UpdatePeriodRequest implements Action {
  public readonly type = EPeriodsChangesActions.UpdatePeriodRequest;

  constructor(public periodId: number, public data: IPeriod) {}
}

export class UpdatePeriodSuccess implements Action {
  public readonly type = EPeriodsChangesActions.UpdatePeriodSuccess;
}

export class UpdatePeriodFailure implements Action {
  public readonly type = EPeriodsChangesActions.UpdatePeriodFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearUpdatePeriodErrors implements Action {
  public readonly type = EPeriodsChangesActions.ClearUpdatePeriodErrors;
}

export class DeletePeriodRequest implements Action {
  public readonly type = EPeriodsChangesActions.DeletePeriodRequest;

  constructor(public periodId: number) {}
}

export class DeletePeriodSuccess implements Action {
  public readonly type = EPeriodsChangesActions.DeletePeriodSuccess;
}

export class DeletePeriodFailure implements Action {
  public readonly type = EPeriodsChangesActions.DeletePeriodFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeletePeriodErrors implements Action {
  public readonly type = EPeriodsChangesActions.ClearDeletePeriodErrors;
}

export class AddHolidaysToPeriodRequest implements Action {
  public readonly type = EPeriodsChangesActions.AddHolidaysToPeriodRequest;

  constructor(public periodId: number, public data: IPeriod) {}
}

export class AddHolidaysToPeriodSuccess implements Action {
  public readonly type = EPeriodsChangesActions.AddHolidaysToPeriodSuccess;
}

export class AddHolidaysToPeriodFailure implements Action {
  public readonly type = EPeriodsChangesActions.AddHolidaysToPeriodFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAddHolidaysToPeriodErrors implements Action {
  public readonly type = EPeriodsChangesActions.ClearAddHolidaysToPeriodErrors;
}

export class AddHolidaysToSeveralGroupsRequest implements Action {
  public readonly type =
    EPeriodsChangesActions.AddHolidaysToSeveralGroupsRequest;

  constructor(public data: IMassHolidays) {}
}

export class AddHolidaysToSeveralGroupsSuccess implements Action {
  public readonly type =
    EPeriodsChangesActions.AddHolidaysToSeveralGroupsSuccess;
}

export class AddHolidaysToSeveralGroupsFailure implements Action {
  public readonly type =
    EPeriodsChangesActions.AddHolidaysToSeveralGroupsFailure;
  constructor(public errors: IFormErrors) {}
}

export class ClearAddHolidaysToSeveralGroups implements Action {
  public readonly type = EPeriodsChangesActions.ClearAddHolidaysToSeveralGroups;
}

export class DeletePeriodHolidaysRequest implements Action {
  public readonly type = EPeriodsChangesActions.DeletePeriodHolidaysRequest;

  constructor(public periodId: number, public number: number) {}
}

export class DeletePeriodHolidaysSuccess implements Action {
  public readonly type = EPeriodsChangesActions.DeletePeriodHolidaysSuccess;
}

export class DeletePeriodHolidaysFailure implements Action {
  public readonly type = EPeriodsChangesActions.DeletePeriodHolidaysFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearDeletePeriodHolidaysErrors implements Action {
  public readonly type = EPeriodsChangesActions.ClearDeletePeriodHolidaysErrors;
}

export class SetPeriodThemeRequest implements Action {
  public readonly type = EPeriodsChangesActions.SetPeriodThemeRequest;

  constructor(public id: number, public data: { theme: string }) {}
}

export class SetPeriodThemeSuccess implements Action {
  public readonly type = EPeriodsChangesActions.SetPeriodThemeSuccess;

  constructor(public payload: IPeriod) {}
}

export class SetPeriodThemeFailure implements Action {
  public readonly type = EPeriodsChangesActions.SetPeriodThemeFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearSetPeriodTheme implements Action {
  public readonly type = EPeriodsChangesActions.ClearSetPeriodTheme;
}

export type PeriodsChangesActions =
  | UpdatePeriodRequest
  | UpdatePeriodSuccess
  | UpdatePeriodFailure
  | ClearUpdatePeriodErrors
  | CreatePeriodRequest
  | CreatePeriodSuccess
  | CreatePeriodFailure
  | ClearCreatePeriodErrors
  | DeletePeriodRequest
  | DeletePeriodSuccess
  | DeletePeriodFailure
  | ClearDeletePeriodErrors
  | AddHolidaysToPeriodRequest
  | AddHolidaysToPeriodSuccess
  | AddHolidaysToPeriodFailure
  | ClearAddHolidaysToPeriodErrors
  | SetPeriodThemeRequest
  | SetPeriodThemeSuccess
  | SetPeriodThemeFailure
  | ClearSetPeriodTheme
  | AddHolidaysToSeveralGroupsRequest
  | AddHolidaysToSeveralGroupsSuccess
  | AddHolidaysToSeveralGroupsFailure
  | ClearAddHolidaysToSeveralGroups
  | DeletePeriodHolidaysRequest
  | DeletePeriodHolidaysSuccess
  | DeletePeriodHolidaysFailure
  | ClearDeletePeriodHolidaysErrors;
